// Énumérations centralisées pour cohérence UI / filtres / chips.

// Valeurs = BookingStatusEnum backend (le filtre `status` fait un
// BookingStatusEnum.valueOf() : une valeur inconnue provoque une erreur).
export const BOOKING_STATUS = {
  SCHEDULED: { label: "Programmé", color: "primary" },
  PAYMENT_CONFIRMATION: { label: "Paiement en attente", color: "warning" },
  PAYMENT_EXPIRED: { label: "Paiement expiré", color: "default" },
  CONFIRMED: { label: "Confirmé", color: "info" },
  COMING: { label: "Imminent", color: "info" },
  FINISHED: { label: "Séance finie", color: "success" },
  DONE: { label: "Terminé", color: "success" },
  INVOICED: { label: "Facturé", color: "success" },
  CANCELED_BY_USER: { label: "Annulé (patient)", color: "error" },
  CANCELED_BY_PRO: { label: "Annulé (pro)", color: "error" },
  NO_SHOW: { label: "Non présenté", color: "default" },
};

// Statuts terminaux : plus d'annulation / déplacement possible.
export const BOOKING_TERMINAL_STATUSES = [
  "DONE", "INVOICED", "CANCELED_BY_USER", "CANCELED_BY_PRO", "NO_SHOW", "PAYMENT_EXPIRED",
];
export const isBookingCancelled = (status) =>
  status === "CANCELED_BY_USER" || status === "CANCELED_BY_PRO";

// BookingEnum backend : VISIO | OFFICE uniquement.
export const BOOKING_TYPE = {
  VISIO: { label: "Visio", color: "info" },
  OFFICE: { label: "Cabinet", color: "primary" },
};

// UserEnum backend (valeur JSON). Il n'existe pas de type ADMIN : les
// admins sont désignés par liste blanche (ADMIN_EMAILS).
export const USER_TYPE = {
  PATIENT: { label: "Patient", color: "primary" },
  PROFESSIONAL: { label: "Professionnel", color: "secondary" },
  AMBASSADOR: { label: "Ambassadeur", color: "warning" },
  AFFILIATE: { label: "Affilié", color: "info" },
};

export const isProType = (type) => type === "PROFESSIONAL" || type === "PRO";

// AccountStatusEnum backend.
export const ACCOUNT_STATUS = {
  ACTIVE: { label: "Actif", color: "success" },
  INACTIVE: { label: "Inactif", color: "default" },
  SUSPENDED: { label: "Suspendu", color: "warning" },
  PENDING: { label: "En attente", color: "warning" },
  TO_VALIDATE: { label: "À valider", color: "warning" },
};

export const FORFAIT_STATUS = {
  PROPOSE: { label: "Proposé", color: "info" },
  PAYE: { label: "Payé", color: "success" },
  TERMINE: { label: "Terminé", color: "default" },
  ANNULE: { label: "Annulé", color: "error" },
};

// PaymentStatusEnum backend.
export const PAYMENT_STATUS = {
  AUTHORIZED: { label: "Autorisé", color: "warning" },
  AUTHORIZED_EXTENDED: { label: "Autorisation prolongée", color: "warning" },
  CAPTURED: { label: "Encaissé", color: "success" },
  PAID_SCHEDULED: { label: "Versement planifié", color: "info" },
  PAID_EXECUTED: { label: "Versé", color: "success" },
  TRANSFERRED_TO_STRIPE_ACCOUNT: { label: "Transféré (Stripe)", color: "success" },
  PAID_OUT_TO_BANK: { label: "Viré en banque", color: "success" },
  REFUNDED: { label: "Remboursé", color: "info" },
  CANCELED: { label: "Annulé", color: "default" },
  // Statuts de BookingDTO.paymentInformation.paymentStatus
  PENDING: { label: "En attente", color: "warning" },
  REQUIRES_PAYMENT: { label: "Paiement requis", color: "warning" },
  CAPTURE_FAILED: { label: "Échec d'encaissement", color: "error" },
  PARTIALLY_REFUNDED: { label: "Remboursé en partie", color: "info" },
  REFUND_FAILED: { label: "Échec du remboursement", color: "error" },
  PAID_BY_URA: { label: "Payé en points Ura", color: "success" },
};

export const REPORT_STATUS = {
  NEW: { label: "Nouveau", color: "warning" },
  IN_PROGRESS: { label: "En cours", color: "info" },
  RESOLVED: { label: "Résolu", color: "success" },
  DISMISSED: { label: "Rejeté", color: "default" },
};

export const SUGGESTION_STATUS = {
  PENDING: { label: "En attente", color: "warning" },
  VALIDATED: { label: "Validée", color: "success" },
  REJECTED: { label: "Rejetée", color: "error" },
};

export const FRIENDSHIP_STATUS = {
  PENDING: { label: "En attente", color: "warning" },
  ACCEPTED: { label: "Acceptée", color: "success" },
  REJECTED: { label: "Rejetée", color: "error" },
  BLOCKED: { label: "Bloquée", color: "default" },
};

export const NOTIFICATION_TYPE = {
  BOOKING: { label: "Rendez-vous", color: "primary" },
  MESSAGE: { label: "Message", color: "info" },
  REVIEW: { label: "Avis", color: "warning" },
  SYSTEM: { label: "Système", color: "default" },
  PAYMENT: { label: "Paiement", color: "success" },
};

export const SUPPORT_PRIORITY = {
  LOW: { label: "Faible", color: "default" },
  NORMAL: { label: "Normale", color: "info" },
  HIGH: { label: "Haute", color: "warning" },
  URGENT: { label: "Urgente", color: "error" },
};

export const GENDER = {
  MALE: { label: "Homme" },
  FEMALE: { label: "Femme" },
  OTHER: { label: "Autre" },
};

export const PROVIDER = {
  LOCAL: { label: "Local" },
  GOOGLE: { label: "Google" },
  FACEBOOK: { label: "Facebook" },
  APPLE: { label: "Apple" },
};

export const choicesFromEnum = (enumObj) =>
  Object.entries(enumObj).map(([id, { label }]) => ({ id, name: label }));

export const labelOf = (enumObj, id) =>
  (enumObj[id] && enumObj[id].label) || id || "—";

export const colorOf = (enumObj, id) =>
  (enumObj[id] && enumObj[id].color) || "default";
